import { ExperimentActions } from 'client/actions/actionTypes'
import { ExperimentInterface } from 'client/Interfaces/ExperimentsInterface'
import { ReducerBuilder } from 'client/reducers/ReducerBuilder'

type PayloadType = ExperimentInterface[] | null

export interface ExperimentsState {
  loaded: boolean
  experiments: PayloadType
}

export const INITIAL_STATE = {
  loaded: false,
  experiments: null,
}

const loadExperiments = (state: ExperimentsState = INITIAL_STATE, payload: PayloadType): ExperimentsState => {
  if (!payload || payload.constructor !== Array || payload.length === 0 || payload.every((value) => value === null)) {
    return {
      loaded: true,
      experiments: null,
    }
  } else {
    return {
      loaded: true,
      experiments: payload,
    }
  }
}

export default new ReducerBuilder<ExperimentsState, PayloadType | string>(INITIAL_STATE)
  .mapAction(ExperimentActions.LOAD_EXPERIMENTS, loadExperiments)
  .build()
